import { Component, Input } from '@angular/core';

@Component({
  selector: 'customer-logo',
  templateUrl: './customer-logo.component.html',
  standalone: false,
  styleUrls: ['./customer-logo.component.scss'],
})
export class CustomerLogoComponent {
  @Input() logo?: string | null;
}
